import investorPortalClient from './clients/investorPortal';

export function create(payload: any) {
  return investorPortalClient.post('/investor_contacts', payload);
}
